import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// GUARDS/GUARDAS  --------------------------------------------------------
import { LoginGuard } from './guards/login.guard';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { RestorePasswordComponent } from './pages/restore-password/restore-password.component';

// MODULES/MODULOS  -------------------------------------------------------
import { AdminModule } from './admin/admin.module';
import { UserModule } from './user/user.module';
import { GuestGuard } from './services/guards/guest.guard';
import { MapaIglesiasComponent } from './admin/pages/iglesias/mapa-iglesias/mapa-iglesias.component';

const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
        canActivate: [GuestGuard]
    },
    {
        path: 'registro',
        component: RegisterComponent,
        canActivate: [GuestGuard]
    },
    {
        path: 'recuperar-contraseña',
        component: RestorePasswordComponent
    },
    {
        path: 'mapa',
        component: MapaIglesiasComponent
    },
    {
        path: 'admin',
        //loadChildren: './admin/admin.module#AdminModule',
        loadChildren: () => AdminModule,
        canActivate: [LoginGuard]
    },
    {
        path: 'user',
        //loadChildren: './user/user.module#UserModule',
        loadChildren: () => UserModule,
        canActivate: [LoginGuard]
    },
    {
        path: '**',
        redirectTo: '/'
    }
];

/*
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class appRouting { }
*/

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule],
})
export class appRouting { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts